/**
 * SIM-1502 — T1 universal panel, collapsed by default because daily work is tenant-scoped. When
 * expanded it shows a destructive "edits apply to every tenant" alert, then the read-only system
 * prompt, universal skills and universal field definitions. There is intentionally no universal
 * table-definitions editor. Content renders only when expanded, so its queries stay unfired.
 */
import { useState } from "react";
import { SystemPromptView } from "./SystemPromptView";
import { UniversalFieldDefsEditor } from "./UniversalFieldDefsEditor";
import { UniversalSkillsEditor } from "./UniversalSkillsEditor";

export function UniversalPanel() {
  const [open, setOpen] = useState(false);

  return (
    <section className="rounded-md border border-border" data-testid="universal-panel">
      <button
        type="button"
        aria-expanded={open}
        aria-controls="universal-panel-body"
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left hover:bg-muted/40"
        onClick={() => setOpen((v) => !v)}
      >
        <div>
          <h2 className="text-xl font-semibold text-foreground">Universal context</h2>
          <p className="text-sm text-muted-foreground">
            System prompt and cross-tenant defaults. Edits affect every tenant.
          </p>
        </div>
        <span aria-hidden="true" className="text-sm text-muted-foreground">
          {open ? "Collapse" : "Expand"}
        </span>
      </button>

      {open && (
        <div id="universal-panel-body" className="space-y-6 border-t border-border p-4">
          <div
            role="alert"
            className="rounded-md bg-destructive/10 p-3 text-sm text-destructive"
            data-testid="universal-warning-banner"
          >
            <strong className="font-semibold">Universal context.</strong> Edits here apply to every
            tenant.
          </div>
          <SystemPromptView />
          <UniversalSkillsEditor />
          <UniversalFieldDefsEditor />
        </div>
      )}
    </section>
  );
}
